import React, { useState } from 'react';
import { Box, Button, Checkbox, CircularProgress, Typography } from "@mui/material";
import useAppInfo from '../../hooks/appInfo.hook';
import { useUser } from "../../contexts/user.context";
import { mobileAppPlatforms, PLATFORMS } from '../../utils/constants';
import { mobilizeiStoresService } from '../../services/mobilizei/stores.service';
import _ from 'lodash';
import { showApiError } from '../../utils/errors';

export default function PublishButton({ platform, disabled }) {
    const { isAndroidAppPublished, isiOSAppPublished } = useAppInfo();
    const { user, setUser } = useUser();

    const isDisabled = user?.store?.platformId === PLATFORMS.CONVERTR ? false : disabled || _.isEmpty(user?.subscription);

    const [isContentAgreenmentChecked, setIsContentAgreenmentChecked] = useState(false);
    const [isTermAgreementChecked, setIsTermAgreementChecked] = useState(false);
    const [isPublishing, setIsPublishing] = useState(false);

    function publish() {
        setIsPublishing(true);

        let publishStatus = '';
        if (platform === mobileAppPlatforms.ANDROID) {
            publishStatus = isAndroidAppPublished() ? 'publishing' : 'pending_listing_creation';
        } else {
            publishStatus = isiOSAppPublished() ? 'publishing' : 'pending_listing_creation';
        }

        let data = {}
        _.set(data, `platforms.${platform}.publishStatus`, publishStatus);
        _.set(data, `platforms.${platform}.publishStatusUpdatedAt`, new Date());
        _.set(data, `platforms.${platform}.lastPublishRequestedAt`, new Date());

        setUser({ ...user, store: _.merge(user.store, data) });
        setIsPublishing(false);

        mobilizeiStoresService.setMobileAppPublishStatus(
            user?.store?.platformId,
            user?.store?.id,
            platform,
            publishStatus
        )
            .then(() => {
                let data = {}
                _.set(data, `platforms.${platform}.publishStatus`, publishStatus);
                _.set(data, `platforms.${platform}.publishStatusUpdatedAt`, new Date());
                _.set(data, `platforms.${platform}.lastPublishRequestedAt`, new Date());

                // Update the local user data to match the data that was 
                // updated on the backend
                setUser({ ...user, store: _.merge(user.store, data) });
            })
            .catch(e => {
                showApiError(e.error);
            })
            .finally(() => {
                setIsPublishing(false);
            })
    }

    return (
        <Box display='flex' flexDirection='column' marginTop={8}>
            {isPublishing ? <CircularProgress /> :
                <>
                    <Box display='flex' flexDirection='column'>
                        <Box display='flex' alignItems='center' marginBottom={1} sx={{ cursor: 'pointer' }}>
                            <Checkbox checked={isContentAgreenmentChecked} sx={{ paddingLeft: 0 }} disabled={isDisabled} onClick={() => setIsContentAgreenmentChecked(!isContentAgreenmentChecked)} />
                            {platform === mobileAppPlatforms.ANDROID 
                                ? (
                                    <Typography align="justify" variant="subtitle1">
                                        Declaro que os produtos e conteúdos da minha loja estão em conformidade com a 
                                        <a target="_blank" href="https://support.google.com/googleplay/android-developer/topic/9877466?hl=pt-BR"> Política de Conteúdo Restrito da Play Store</a>
                                        .
                                    </Typography>
                                )
                                : (
                                    <Typography align="justify" variant="subtitle1">
                                        Declaro que os produtos e conteúdos da minha loja estão em conformidade com as 
                                        <a target="_blank" href="https://developer.apple.com/app-store/review/guidelines/"> Diretrizes da App Store</a>
                                        .
                                    </Typography>
                                )
                            }
                        </Box>

                        <Box display='flex' alignItems='center' marginBottom={1} sx={{ cursor: 'pointer' }}>
                            <Checkbox checked={isTermAgreementChecked} sx={{ paddingLeft: 0 }} disabled={isDisabled} onClick={() => setIsTermAgreementChecked(!isTermAgreementChecked)}/>
                            <Typography align="justify" variant="subtitle1">
                                Li e concordo com os <a href="https://mobilizei.com.br/termos-de-uso" target="_blank">Termos de Uso</a> da Mobilizei.
                            </Typography>
                        </Box>
                    </Box>

                    <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' marginTop={2}>
                        <Button disabled={!isContentAgreenmentChecked || !isTermAgreementChecked || isDisabled} variant="contained" onClick={publish}>
                            publicar
                        </Button>
                    </Box>
                </>
            }
        </Box>
    )
}